import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { KostenstelleListView } from './list-view/kostenstelle.list-view';
import { FieldOkSearchConfig } from '@softapps/core/pages';
import { KostenstelleFieldOkSearchResultView } from './search-result-view/search-result-view.component';

export const kostenstelleFieldOk: FieldOkConfig = {
  name: 'kst',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kostenstelle}} - {{kontotext1}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: KostenstelleListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};
export const kostenstelleMultiselectFieldOk: FieldOkConfig = {
  name: 'kst',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kostenstelle}} - {{kontotext1}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: KostenstelleListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};

export const kostenstelleQueryFieldOk: FieldOkConfig = {
  name: 'kst',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{kostenstelle}} - {{kontotext1}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: KostenstelleListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};

export const kostenstelleSearchPageConfig: FieldOkSearchConfig<any> = {
  name: 'kst',
  view: KostenstelleFieldOkSearchResultView,
  options: {
    autoLoad: true,
  },
};
